import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Osoby',
    financial_metrics: 'Wskaźniki finansowe',
    onboarding_and_quality: 'Wdrożenie i jakość',
    subscriptions: 'Aktywne subskrypcje',
    payments: 'Płatności',
    last_invoices: 'Ostatnie faktury',
  },
  fields: {
    google_profile: 'Profil Google',
    owner_name: 'Imię właściciela',
    owner_phone_number: 'Telefon właściciela',
    company_phone_number: 'Telefon restauracji',
    address: 'Adres',
    onboarding_manager: 'Menedżer wdrożenia',
    sales_manager: 'Menedżer sprzedaży',
    last_30_days_sales: 'Przychód z ostatnich 30 dni',
    lifetime_sales: 'Łączny przychód',
    monthly_sales_other_platforms: 'Sprzedaż w aplikacjach dostawczych',
    last_payout: 'Ostatnia wypłata',
    potential_tier: 'Wynik potencjalny',
    current_tier: 'Wynik IST',
    signed_at: 'Data zamknięcia',
    live_from: 'Data uruchomienia',
    onboarding_quality_score: 'Wynik jakości uruchomienia',
    is_google_business_available: 'Google Business dostępny',
    is_smart_pricing_configured: 'Tańsze ceny niż Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Ulotka promo wysłana',
    is_menu_fully_configured: 'Wszystkie pozycje menu dostępne',
    has_offers_on_competitor_platforms:
      'Czy restauracja ma aktywne oferty na Wolt, Uber, Lieferando (z wyjątkiem oferty darmowej dostawy)?',
    is_instagram_story_shared: 'Story na Instagramie udostępnione właścicielowi',
    is_order_system_connected_to_website:
      'Strona Foodamigos podłączona LUB przycisk zamówień online dodany na stronie restauracji',
    delivery_mode: 'Kierowcy',
    has_storefront: 'Strona {{provider}}',
    screening_date: 'Data weryfikacji',
  },
  setup_fee: {
    title: 'Opłata wdrożeniowa',
    status: {
      [InvoiceStatus.Paid]: 'Opłacone',
      [InvoiceStatus.Pending]: 'Oczekujące',
      [InvoiceStatus.Processing]: 'W trakcie',
      [InvoiceStatus.Refunded]: 'Zwrócone',
      [InvoiceStatus.PartiallyRefunded]: 'Częściowo zwrócone',
      [InvoiceStatus.Failed]: 'Nieudane',
    },
  },
  labels: {
    yes: 'Tak',
    no: 'Nie',
    month: 'Miesiąc',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Aktywny',
    [CompanyOperationalStatus.Paused]: 'Wstrzymany',
    [CompanyOperationalStatus.Suspended]: 'Utracony',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Standard',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Miesięczny',
    [SubscriptionTerm.Annual]: 'Roczny',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Własni kierowcy',
    [DeliveryMode.External]: 'Kierowcy {{provider}}',
  },
  buttons: {
    view_details: 'Pokaż szczegóły',
    open: 'Otwórz',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
